import { render, staticRenderFns } from "./rightInformation.vue?vue&type=template&id=982454c6&scoped=true&"
import script from "./rightInformation.js?vue&type=script&lang=js&"
export * from "./rightInformation.js?vue&type=script&lang=js&"
import style0 from "./rightInformation.vue?vue&type=style&index=0&id=982454c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982454c6",
  null
  
)

export default component.exports